import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { useAssets, useLocale, useUser } from 'hooks';
import { useHistory } from 'react-router-dom';

import { Page, ProfileHeader } from 'ui';
import { UserRole } from 'context/user/userContext/UserContext.types';
import { AppRoute } from 'routing/AppRoute.enum';

import { OwnerDashboard } from './dashboards/OwnerDashboard';
import { InstallerDashboard } from './dashboards/InstallerDashboard';
import { VerifierDashboard } from './dashboards/VerifierDashboard';
import { ManufacturerDashboard } from './dashboards/ManufacturerDashboard';
import { useStyles } from './Dashboard.styles';

export const Dashboard = () => {
  const { user } = useUser();
  const { formatMessage } = useLocale();
  const { assets, getAssets } = useAssets();
  const { push } = useHistory();
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const fetchTokens = async () => {
    if (user) {
      setIsLoading(assets?.length === 0);
      setIsError(false);
      try {
        await getAssets();
      } catch (e) {
        setIsError(true);
        setIsLoading(false);
      }
    } else {
      setIsError(true);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchTokens();
  }, []);

  const getDashboard = () => {
    const props = {
      isLoading,
      isError,
      fetchTokens,
    };
    const dashboards = {
      [UserRole.Manufacturer]: <ManufacturerDashboard {...props} />,
      [UserRole.Installer]: <InstallerDashboard {...props} />,
      [UserRole.Verifier]: <VerifierDashboard {...props} />,
      [UserRole.Owner]: <OwnerDashboard {...props} />,
      [UserRole.GoverningBody]: null,
    };
    if (!user) return <div />;
    return dashboards[user.role];
  };
  if (!user) {
    push(AppRoute.home);
    return <div />;
  }

  const getName = () => {
    if (user.name) {
      return user.name;
    }

    return `${user.firstName} ${user.lastName}`;
  };

  return (
    <Page title={formatMessage({ id: 'dashboard.page_title' })} backPage={AppRoute.home}>
      <Grid container>
        <Grid item xs={12}>
          <ProfileHeader
            name={getName()}
            email={user.email}
            role={user.role}
            avatar={user.avatar}
            address={user.address}
          />
        </Grid>
        <Grid item xs={12} className={classes.container}>
          {getDashboard()}
        </Grid>
      </Grid>
    </Page>
  );
};
